import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Access } from "common";
import { Page, Panel, Loading, Breadcrumbs, Pagination } from "components";
import points from "services/points";
import queryString from "query-string";
import Filters from "../components/Filters";
import { debounce } from "lodash";

export default function List(props) {
  const initialState = {
    name: "",
    reason: "",
  };

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "Pontos", to: "/points" },
    { name: "Listagem (Pontos - Lista de CPFs)", to: "" },
  ];

  const manageAccess = Access.hasPermissions(["manage-points-assigner"]);

  const [bulkPoints, setBulkPoints] = useState([]);
  const [meta, setMeta] = useState({});
  const [pagination, setPagination] = useState(getCurrentPagination());
  const [filters, setFilters] = useState(initialState);
  const [loading, setLoading] = useState(true);

  function getCurrentPagination() {
    const params = queryString.parse(props.location.search);
    const page = (params.page && Number(params.page)) || 1;
    const per = (params.per && Number(params.per)) || 25;

    return { page, per };
  }

  const fetchPoints = async () => {
    setLoading(true);

    const options = {
      params: {
        per: pagination.per,
        page: pagination.page,
        name: filters.name,
        reason: filters.reason,
      },
    };

    try {
      const { data } = await points.get(
        "/experience/bulk_points_assigner",
        options
      );
      setBulkPoints(data.data);
      setMeta(data.meta);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const debouncedFetch = debounce(fetchPoints, 300); // Adjust debounce timing here
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
  }, [filters, pagination]);

  const handleFiltersClean = (event) => {
    event.preventDefault();
    setFilters(initialState);
  };

  useEffect(() => {
    if (props.location.search) {
      const params = queryString.parse(props.location.search);
      const page = params.page;

      if (page > 1) props.history.push("/points/cpf-list");
    }

    setPagination((prevState) => ({
      ...prevState,
      page: 1,
    }));
  }, [filters]);

  useEffect(() => {
    const { page, per } = getCurrentPagination();

    if (page !== pagination.page || per !== pagination.per) {
      setPagination({ per, page });
    }
  });

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Page.Title>Listagem (Pontos - Lista de CPFs)</Page.Title>

      <Filters
        onChange={handleFilterChange}
        filters={filters}
        onClean={handleFiltersClean}
      />

      <Panel className="panel-list">
        {manageAccess && (
          <Link
            to="/points/cpf-list/create"
            className="button-add margin-bottom-20"
          >
            Atribuir Pontos para uma Lista de CPFs
          </Link>
        )}
        {loading ? (
          <Loading type="page" size="x-large" />
        ) : (
          <>
            <table className="contact-table table table-curved table-striped">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Motivo da pontuação</th>
                  <th className="text-right">Ação</th>
                </tr>
              </thead>
              <tbody>
                {bulkPoints.length > 0 ? (
                  bulkPoints.map((point, index) => (
                    <tr key={index}>
                      <td>{point.attributes.name}</td>
                      <td>{point.attributes.score_reason}</td>
                      <td className="text-right">
                        {Access.hasPermissions("manage-points-assigner") && (
                          <Link
                            to={{
                              pathname: `/points/cpf-list/${point.id}/show`,
                              state: {
                                created_at: point.created_at,
                              },
                            }}
                            className="button-icon"
                          >
                            <span className="glyph glyph-eye" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      Nenhum resultado encontrado
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="8" />
                </tr>
              </tfoot>
            </table>
            <Pagination
              className="m-t-20"
              current={pagination.page}
              per={pagination.per}
              total={meta.total_pages}
              {...props}
            />
          </>
        )}
      </Panel>
    </Page>
  );
}
